export default "__VITE_ASSET__HUPCS9pj__"